const PropertyDetailSkeleton = () => (
  <div className="property-detail-page property-detail-page--loading" aria-busy="true" aria-label="Loading property">
    <div className="property-detail-page__top skeleton-block" />
    <div className="property-detail-hero property-detail-hero--skeleton">
      <div className="property-detail-hero__gallery skeleton-block skeleton-block--tall" />
      <div className="property-detail-hero__summary skeleton-block skeleton-block--card" />
    </div>
    <div className="property-detail-page__grid">
      <div className="skeleton-block skeleton-block--section" />
      <div className="skeleton-block skeleton-block--section" />
      <div className="skeleton-block skeleton-block--section" />
    </div>
  </div>
);

export default PropertyDetailSkeleton;
